t = require('views/internal/teacup-with-helpers')('header_warning_account_transfer_required_big')

module.exports = t.renderable ({ targetDate, enterpriseDisplayName, isAdmin }) ->
  t.div '.centered-banner', ->
    t.div '.sso-notice', ->
      t.p ->
        t.format 'convert-to-enterprise-member', { enterpriseDisplayName, targetDate }
      t.p ->
        if isAdmin
          t.format 'admins-must-convert'
        else
          t.format 'will-deactivate', { enterpriseDisplayName }
    t.p '.u-bottom', ->
      t.button '.primary.wide.js-begin-transfer', { type: 'button' }, ->
        t.format 'start-conversion'
      t.text " "
      t.a '.quiet.js-dismiss-account-transfer', { href: '#' }, ->
        t.format 'do-later'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_warning_account_transfer_required_big.coffee